/**
 * tutorCloseAccountViewModel — ce que « Fermer mon compte » du tuteur lit dans le store : la phrase
 * qui remplace le bouton tant qu'il a des élèves (`DeleteAccountScreen.js`).
 *
 * Patron C (le compte est déjà là). Mémoïsé sur le seul booléen qu'il rend : le compte change
 * d'identité à chaque relecture, pas le fait d'avoir des élèves.
 */
import { createSelector } from "reselect"

import {
    CLOSE_BLOCKED_WITH_STUDENTS,
    tutorHasStudents,
    type ApiTutorSettingsUser,
} from "../../../adapters/tutor/Account/tutorSettingsAdapter"
import { selectAccount } from "../../shared/displayedStudent"

export type TutorCloseAccountViewModel = {
    closeBlockedReason: string | null
}

const selectHasStudents = (state: unknown): boolean =>
    tutorHasStudents(selectAccount(state as never) as ApiTutorSettingsUser | undefined)

export const tutorCloseAccountViewModel = createSelector(
    [selectHasStudents],
    (hasStudents): TutorCloseAccountViewModel => ({
        closeBlockedReason: hasStudents ? CLOSE_BLOCKED_WITH_STUDENTS : null,
    })
)
